import { render, staticRenderFns } from "./BatchMovementPanel.vue?vue&type=template&id=68b1b362"
import script from "./BatchMovementPanel.vue?vue&type=script&lang=js"
export * from "./BatchMovementPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports